import React, { FC, ReactNode } from 'react';
import { Box, TableCell, TableCellProps } from '@mui/material';
import { withHighLight } from 'hoc/with-high-light';

type CellComponentProps = TableCellProps & {
    rightAdornment?: ReactNode;
};

const CellComponent: FC<CellComponentProps> = ({ children, rightAdornment, ...props }) => (
    <TableCell {...props}>
        <Box display="flex" alignItems="flex-start" gap={1} width="100%">
            <Box
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {children}
            </Box>

            {/* Right slot */}
            {rightAdornment && (
                <Box flexShrink={0} display="flex" alignItems="center">
                    {rightAdornment}
                </Box>
            )}
        </Box>
    </TableCell>
);

const TableCellWithHighLighting: FC<
    {
        data: string;
        originalData: string;
        rightAdornment?: ReactNode;
    } & TableCellProps
> = withHighLight(CellComponent);

export default TableCellWithHighLighting;
